
function setCartItemLicenseAreaImage(){
  const licensePlatePreviewElements = document.querySelectorAll('.cart-drawer .cart-plate-preview .cart-area-image');
  licensePlatePreviewElements.forEach((element) => {
    let tmpAreaCode = element.getAttribute('data-area-code');
    let imageUrl = getImageUrlForAreaCodeIcons(tmpAreaCode);
    //console.log('Area Code in Cart: ', imageUrl);
    if(imageUrl)
    element.src = imageUrl;
  });
  
  
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.injectGclidAttr();
    this.injectSrsltidAttr();

    console.log('CartDrawer constructed');
  }

  injectGclidAttr(){
    // check if the form already exists
    const drawerForm = document.getElementById('CartDrawer-Form');
    if(drawerForm){
      const get_gclid = localStorage.getItem('SKgclid') || (document.cookie.match(/(^|;) ?SKgclid=([^;]*)(;|$)/) || [])[2];
      if (get_gclid && document.getElementById('gclidFieldDrawer')) {
        document.getElementById('gclidFieldDrawer').value = get_gclid;
      }
      
    }
  }

  injectSrsltidAttr(){
    // check if the form already exists
    const drawerForm = document.getElementById('CartDrawer-Form');
    if(drawerForm){
      const get_srsltid = localStorage.getItem('SKsrsltid') || (document.cookie.match(/(^|;) ?SKsrsltid=([^;]*)(;|$)/) || [])[2];
      if (get_srsltid && document.getElementById('srsltidFieldDrawer')) {
        document.getElementById('srsltidFieldDrawer').value = get_srsltid;
      }
      
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      if (window.innerWidth > 900) {
        event.preventDefault();
        this.open(cartLink);
      }else{
        //window.location="/cart";
      }
      
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    console.log('Cart Opened');
   // console.log('triggeredBy',triggeredBy);
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    setCartItemLicenseAreaImage();
    
    this.addEventListener(
      'transitionend',
      () => {
        localStorage.setItem('oneOffKeepCartClosed', false);
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        //console.log("Focus Element",focusElement);
        //console.log("Container to trap focus on",containerToTrapFocusOn);
        if(focusElement && containerToTrapFocusOn)
        trapFocus(containerToTrapFocusOn, focusElement);

        var countdownElement = document.querySelector('.delivery-hint .countdown-replacer');
        var countdownContainerElement = document.querySelector('.delivery-hint');
        var countdownDuration = (10 * 60)-1; // Countdown duration in seconds (10 minutes)
        countdownDuration = globalDeliveryDuration;
        startDeliveryCountdown(countdownDuration,countdownElement,countdownContainerElement);

        var cartEleToUpdateForDeliveryETA = document.querySelectorAll('.delivery-hint .eta-replacer');
        setDeliveryETA(cartEleToUpdateForDeliveryETA,'day_only');
        
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState,openCartDrawer=true) {
    //console.log('Rendering Cart Drawer Contents');
    //console.log('ParsedState in renderContents',parsedState);
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    let oneOffKeepCartClosed = JSON.parse(localStorage.getItem('oneOffKeepCartClosed'));
   // console.log('oneOffKeepCartClosed',oneOffKeepCartClosed);
    if(oneOffKeepCartClosed == true){
        openCartDrawer=false;
    
    }
    
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    
      if(openCartDrawer===true){
        this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
